import { useTranslation } from '../context/TranslationContext';
import './Legal.css';

export default function TOS() {
  const { t } = useTranslation();

  return (
    <div className="legal-page">
      <div className="legal-header">
        <h1>{t('tosTitle')}</h1>
      </div>
      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>{t('tosIntro')}</p>
        </section>
        <section className="legal-section">
          <h2>2. Use of Facebook Login</h2>
          <p>{t('tosFacebook')}</p>
        </section>
        <section className="legal-section">
          <h2>3. User Responsibilities</h2>
          <p>{t('tosResponsibility')}</p>
        </section>
      </div>
    </div>
  );
}
